<template>
  <div class="appeal-handle">
    <div class="handle-title">
      <i class="el-icon-circle-check"></i>
      <span>申诉处理</span>
    </div>
    <div class="handle-buttons">
      <el-button type="success"
                 size="small"
                 :loading="handling"
                 @click="onAppealPass">申诉通过</el-button>
      <el-button type="danger"
                 size="small"
                 :loading="handling"
                 @click="onAppealNotPass">申诉不通过</el-button>
    </div>

    <!-- 第一步：申诉通过弹窗 -->
    <el-dialog title="申诉通过"
               :visible.sync="passDialogVisible"
               :append-to-body="true"
               :modal-append-to-body="true"
               :close-on-click-modal="false"
               width="420px">
      <div class="reject-form">
        <div class="form-item">
          <div class="form-label required">通过原因分类</div>
          <el-select v-model="appealPassForm.reviewer_wrong_reason_key"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="item in passCategoryOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </div>
        <div class="form-item">
          <div class="form-label">备注</div>
          <el-input v-model="appealPassForm.pass_remarks"
                    type="textarea"
                    :rows="4"
                    maxlength="255"
                    show-word-limit
                    placeholder="请填写备注（非必填）"
                    resize="none"/>
        </div>
      </div>
      <p class="pass-tip">提示：申诉确认通过后，工单将同步审核通过</p>
      <div slot="footer">
        <el-button @click="passDialogVisible = false">取消</el-button>
        <el-button type="success"
                   @click="onPassDialogConfirm">确认通过</el-button>
      </div>
    </el-dialog>

    <!-- 申诉不通过弹窗 -->
    <el-dialog title="申诉不通过"
               :visible.sync="rejectDialogVisible"
               :append-to-body="true"
               :modal-append-to-body="true"
               :close-on-click-modal="false"
               width="500px">
      <div class="reject-form">
        <div class="form-item">
          <div class="form-label required">申诉不通过原因</div>
          <el-select v-model="appealRejectForm.reject_reason_key"
                     placeholder="请选择申诉不通过原因"
                     style="width: 100%">
            <el-option v-for="item in rejectCategoryOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </div>
        <div class="form-item">
          <div class="form-label">详细说明</div>
          <el-input v-model="appealRejectForm.reject_remarks"
                    type="textarea"
                    :rows="4"
                    maxlength="255"
                    show-word-limit
                    placeholder="请填写详细说明（选填）"
                    resize="none"/>
        </div>
        <div class="form-item">
          <div class="form-label">工单可修改时间</div>
          <div class="modify-time-row">
            <el-checkbox v-model="appealRejectForm.allow_modify_endtime"
                         class="modify-checkbox">允许工单可修改时间至月日时分秒
            </el-checkbox>
            <el-date-picker size="mini"
                            :disabled="!appealRejectForm.allow_modify_endtime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="appealRejectForm.new_order_endtime"
                            type="datetime"
                            placeholder="选择日期时间"
                            align="center"
                            class="modify-date">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="danger"
                   @click="onRejectDialogConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import QuestionReview from '@views/question-review/question-review.js'
import ReviewBox from '@views/question-review/components/ReviewBox/index'

export default {
  name: 'OrderAppealHandle',
  inject: ['page'],
  props: {},
  data () {
    return {
      handling: false,
      passDialogVisible: false,
      appealPassForm: {
        reviewer_wrong_reason_key: '',
        pass_remarks: '',
      },
      // 通过原因分类，对应后端 ORDER_REVIEWER_WRONG_REASON_* 常量
      passCategoryOptions: [
        {label: '实习生误判', value: 1}, // ORDER_REVIEWER_WRONG_REASON_INTERN_MISJUDGE
        {label: '背景复杂/主观性', value: 2}, // ORDER_REVIEWER_WRONG_REASON_COMPLEX_SUBJECTIVE
      ],
      // 暂存申诉通过弹窗填写的信息，随申诉接口提交
      appealPassParams: null,
      rejectDialogVisible: false,
      appealRejectForm: {
        reject_reason_key: '',
        reject_remarks: '',
        allow_modify_endtime: false,
        new_order_endtime: '',
      },
      // 申诉不通过原因分类，对应后端 ORDER_APPEAL_REJECT_REASON_MAP
      rejectCategoryOptions: [
        {label: '申诉内容与申诉材料不匹配', value: 1},
        {label: '申诉材料不全无法证明', value: 2},
        {label: '申诉材料仅支持申诉补充，不能作为证据二次递交', value: 3},
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
    }),
    // 题目中没有收集门头照的题目（与 OrderReviewButtons 保持一致）
    needGatherMarketPhoto () {
      const title = _.get(this.page, 'questions[1].title')
      if (!title || !_.startsWith(title, '【到达】')) {
        return false
      }
      // 该题目没有所属门店
      if (!this.orderDetail.marketinfo) {
        return false
      }
      // 使用后端计算的值
      return this.orderDetail.needGatherMarketPhoto
    },
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    /**
     * 申诉通过第一步：弹出申诉通过弹窗（通过原因分类 + 备注）
     */
    onAppealPass () {
      this.appealPassForm = {reviewer_wrong_reason_key: '', pass_remarks: ''}
      this.passDialogVisible = true
    },
    /**
     * 申诉通过第二步：弹出与正常审核通过一致的确认框
     */
    onPassDialogConfirm () {
      if (!this.appealPassForm.reviewer_wrong_reason_key) {
        this.$message.error('请选择通过原因分类')
        return
      }
      this.appealPassParams = {...this.appealPassForm}
      this.passDialogVisible = false
      // 与一键审核通过一致：确认后将所有有效题目置为通过
      const validQuestions = QuestionReview().getValidQuestions()
      const marketPhotos = this.needGatherMarketPhoto ? QuestionReview().getAnswerMarketPhotos() : []
      ReviewBox.orderConfirm((data) => {
        validQuestions.forEach(({id}) => {
          QuestionReview().reviewPassed(id)
        })
        this.doOrderAppealPass(data)
      }, this.orderDetail.salary, marketPhotos, this.orderDetail)
    },
    /**
     * 申诉不通过第一步：弹出申诉不通过弹窗（原因分类 + 详细说明）
     */
    onAppealNotPass () {
      // 默认当前时间 +36 小时；若超过任务结束时间，则取任务结束时间
      const plus36Ts = moment().add(36, 'hours').valueOf()
      const taskEndTs = this.orderDetail.taskendtime
        ? moment(this.orderDetail.taskendtime).valueOf()
        : NaN
      const newEndtime = (taskEndTs && plus36Ts > taskEndTs)
        ? moment(taskEndTs).format('YYYY-MM-DD HH:mm:ss')
        : moment(plus36Ts).format('YYYY-MM-DD HH:mm:ss')
      this.appealRejectForm = {
        reject_reason_key: '',
        reject_remarks: '',
        allow_modify_endtime: false,
        new_order_endtime: newEndtime,
      }
      this.rejectDialogVisible = true
    },
    /**
     * 申诉不通过第二步：直接提交
     */
    onRejectDialogConfirm () {
      if (!this.appealRejectForm.reject_reason_key) {
        this.$message.error('请选择申诉不通过原因')
        return
      }
      const { new_order_endtime } = this.appealRejectForm
      if (!new_order_endtime) {
        this.$message.error('请选择允许工单可修改时间')
        return
      }

      const newEndTs = moment(new_order_endtime).valueOf()
      const nowTs = moment().valueOf()
      const taskEndTs = this.orderDetail.taskendtime
        ? moment(this.orderDetail.taskendtime).valueOf()
        : NaN
      const fmt = ts => moment(ts).format('YYYY-MM-DD HH:mm:ss')
      const nowStr = fmt(nowTs)
      const taskEndStr = fmt(taskEndTs)
      const newEndStr = fmt(newEndTs)
      let confirmMsg = null
      if (taskEndTs && newEndTs <= taskEndTs && nowTs > taskEndTs) {
        confirmMsg = `当前时间（${nowStr}）已超过任务结束时间（${taskEndStr}），审核不通过时将关闭此工单，请确认是否需要修改 工单可修改时间？`
      } else if (newEndTs - nowTs <= 6 * 60 * 60 * 1000) {
        confirmMsg = `此工单用户最晚完成时间（${newEndStr}）距离当前时间（${nowStr}）已不足6小时，请确认是否需要修改 工单可修改时间？`
      }
      if (confirmMsg) {
        this.$confirm(
          confirmMsg,
          '提示',
          {
            type: 'warning',
            confirmButtonText: '确认提交',
            cancelButtonText: '返回修改',
          }
        ).then(() => {
          this.doRejectSubmit()
        }).catch(() => {})
        return
      }

      this.doRejectSubmit()
    },
    async doRejectSubmit () {
      try {
        await this.$confirm('确认申诉不通过？工单将不通过退回', '申诉不通过', {
          type: 'warning',
          confirmButtonText: '确认不通过',
          cancelButtonText: '取消',
          confirmButtonClass: 'el-button--danger',
        })
      } catch (e) {
        return
      }
      this.handling = true
      request.common('orderAppealRejectApi', {id: this.orderDetail.orderid, ...this.appealRejectForm}).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})
        // 申诉单已关闭，更新本地状态让详情面板继续展示
        this.markAppealClosed(3)
        this.askBackToList('申诉已驳回！')
      }).catch(() => {}).finally(() => {
        this.handling = false
        this.rejectDialogVisible = false
      })
    },
    /**
     * 处理完成后，申诉单状态已变为终态，但接口可能不再返回已关闭的申诉单，
     * 这里直接更新本地 orderAppeal 的状态，保证详情面板不闪现“暂无申诉信息”
     */
    markAppealClosed (status) {
      const appeal = this.$store.state.orderReview.orderAppeal
      if (appeal) {
        this.$store.commit('orderReview/SET_ORDER_APPEAL', {...appeal, status})
      }
    },
    /**
     * 申诉处理成功后，询问是否返回工单申诉审核列表
     */
    askBackToList (message) {
      this.$confirm(`${message} 是否返回工单申诉审核列表？`, '申诉处理成功', {
        type: 'success',
        confirmButtonText: '返回列表',
        cancelButtonText: '留在本页',
      }).then(() => {
        this.$router.push('/order/appeal/table')
      }).catch(() => {})
    },
    /**
     * 通过请求：参数与 OrderReviewButtons.reviewOrderPass 一致
     */
    doOrderAppealPass (data) {
      let answers = QuestionReview().getRecoveryAnswers(this.page)
      if (data.marketPhotoIndex !== null && answers[1]) {
        answers[1].marketPhotoIndex = data.marketPhotoIndex
      }
      let params = {
        ...this.appealPassParams,
        compensate_point: 20, // 补偿20零豆
        id: this.orderDetail.orderid,
        salary: data.salary,
        templateresultjson: JSON.stringify(answers),
        sec_consumed: 0,
        settle_detail: data.settle_detail,
        rank_score: data.rank_score,
        is_invalid_for_task_group: data.is_invalid_for_task_group,
      }
      this.handling = true
      request.common('orderAppealPassApi', params).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})
        // 申诉单已关闭，更新本地状态让详情面板继续展示，而非查询后显示“暂无申诉信息”
        this.markAppealClosed(2)
        this.askBackToList('申诉通过，工单同步审核通过！')
      }).catch(() => {}).finally(() => {
        this.handling = false
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.appeal-handle {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px 15px;
  margin-bottom: 12px;

  .handle-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #303133;
    margin-bottom: 10px;

    i {
      color: #67c23a;
      font-size: 16px;
    }
  }

  .handle-buttons {
    display: flex;

    .el-button {
      flex: 1;

      & + .el-button {
        margin-left: 12px;
      }
    }
  }
}

::v-deep .pass-tip {
  color: #f56c6c;
  font-size: 12px;
  margin: 0;
}

.modify-time-row {
  display: flex;
  align-items: center;

  .modify-checkbox {
    flex: 1;
    margin-right: 12px;

    ::v-deep .el-checkbox__label {
      white-space: normal;
    }
  }

  .modify-date {
    width: 180px;
    flex-shrink: 0;
  }
}

.reject-form {
  .form-item {
    & + .form-item {
      margin-top: 14px;
    }
  }

  .form-label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;

    &.required::before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewSidebarPanel/OrderAppealHandle.vue